import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import PaymentLogListPage from './PaymentLogList';
import PaymentLogModalPage from './PaymentLogModal';
import './PaymentLog.css';

@inject(
    'PaymentLogStore'
)
@observer
class PaymentLogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    // ON CANCEL

    paymentLogModalOnCancel = () => {
        this.props.PaymentLogStore.setShowPaymentLogModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showPaymentLogModal,
            paymentLogTitle,
        } = this.props.PaymentLogStore;

        return (
            <MainContainer title={t('Payment History')} menukey='payment-history'>
                <Modal
                    title={t(paymentLogTitle)}
                    visible={showPaymentLogModal}
                    width={800}
                    footer={null}
                    onCancel={this.paymentLogModalOnCancel}
                    zIndex={1000}
                >
                    <PaymentLogModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <PaymentLogListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(PaymentLogPage);